import { h, Component } from 'preact';
import dlv from 'dlv';

import { configure } from '../../../config';

import { Desktop } from './device/desktop.js';
import { Tablet } from './device/tablet.js';
import { Phone } from './device/phone.js';

import { initializeTaboolaJs, finalizeTaboolaJs } from '../../pieces/taboola-js';

import { fetchArticleData } from '../../../lib/data';
import { COMMON_CONFIGS, setTheme } from '../../../lib/page';
import { getPageConfig, getDeviceTemplate } from '../../../lib/device';
import { trackContentLoad, trackPageLoad } from '../../../lib/tracking';
import { setLastGamePlayed } from '../../../lib/game';

import { trackingProvider, DIMENSION } from '@cube/track';
import { deviceVariance } from '@cube/blocks';

@trackingProvider({
	[DIMENSION.componentpath]: 'GamePage'
})
@configure({
	...COMMON_CONFIGS,
	pageConfig: 'singleCube.pages.game',
	clientDisplayName: 'clientDisplayName'
})
@deviceVariance()
export default class Game extends Component {

	processPageInformation = (props) => {
		fetchArticleData({ article: props.canonical, ...props })
			.then( res => {
				if (!res || !dlv(res, 'embeds.0')) {
					return this.setState({ error: true, isLoading: false });
				}

				trackContentLoad({
					context: this.context,
					id: dlv(res, 'metadata.canonical_id'),
					title: res.title,
					provider: dlv(res, 'metadata.attribution.provider'),
					vendor: dlv(res, 'metadata.attribution.vendor'),
					type: 'game'
				});

				setLastGamePlayed(res);

				this.setState({ article: res });
			})
			.catch((err) => {
				this.setState({ error: true, isLoading: false });
			});
	};

	componentWillMount() {
		let device = this.props.device,
			pageConfig = getPageConfig(this.props.pageConfig, device);
		this.setState({ pageConfig, Device: getDeviceTemplate({ device, Desktop, Tablet, Phone }) });

		setTheme(pageConfig);
		this.processPageInformation(this.props);
		initializeTaboolaJs({ category: 'auto' });
	}

	componentDidMount() {
		finalizeTaboolaJs();

		trackPageLoad(this.context);
	}

	render( props, { Device, pageConfig, article, error }) {
		return (
			<Device
				article={article}
				error={error}
				{...props}
				pageConfig={pageConfig}
			/>
		);
	}
}
